<template>
    <img v-if="isBrandingLoaded"
         class="company-logo"
         :class="{'branded-logo': isBranded}"
         :src="logo"
         :alt="$t('ewn.logo-alt')" />
</template>

<script>
  import { computed, defineComponent } from 'vue';
  import { useStore } from '@/store';

  export default defineComponent({
    name: 'BrandedLogo',
    setup () {
      const store = useStore();
      const isBranded = computed(() => store.state.branding.isBranded);

      return {
        isBranded,
        isBrandingLoaded: computed(() => store.state.branding.isBrandingLoaded),
        logo: computed(() => isBranded.value
          ? require(`@/assets/${store.state.branding.branding.logoPath}`)
          : require('@/assets/logo.svg'))
      };
    }
  });
</script>

<style lang="scss">

  .company-logo {
    display: block;
    height: 60px;
    margin: 0 auto;
    margin-bottom: 48px;

    &.branded-logo {
      height: 98px;
      margin-bottom: 32px;
    }
  }

  @media (max-height: 600px) {
    .company-logo {
      margin-top: 24px;
      margin-bottom: 24px;
    }
  }

</style>
